<template>
  <div class="metrics-card-skeleton-wrapper">
    <div v-if="isLoading" class="metrics-card-skeleton">
      <div class="metrics-card-skeleton-row">
        <div class="skeleton-text-small"></div>
      </div>
      <div class="metrics-card-skeleton-row large-text">
        <div class="skeleton-text-large"></div>
        <div class="skeleton-percentage"></div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.metrics-card-skeleton {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 7px;
  padding: 20px 24px;
}

.metrics-card-skeleton-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.metrics-card-skeleton-row.large-text {
  gap: 10px;
}

.skeleton-text-small {
  width: 80px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

.skeleton-text-large {
  width: 120px;
  height: 32px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

.skeleton-percentage {
  width: 60px;
  height: 24px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
